var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NewsDetails"},[_c('p',{staticClass:"product-title"},[_vm._v(_vm._s(_vm.newsIdList.Title))]),_c('p',{staticClass:"product-time"},[_vm._v(_vm._s(_vm.newsIdList.CreateTime))]),_c('p',{staticClass:"product-content"},[_vm._v(_vm._s(_vm.newsIdList.Content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }